import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { TourSignupProps, PropertyContext, tourSignedUpPath, TourPage } from '../TourRouter';
import { useContext, useEffect, useState } from 'react';
import GuestCardLoadFailureDisplay from '../display/GuestCardLoadFailureDisplay';
import '../../../../../styles/TourPage.css';
import { PageProgress, scheduleTour, updatePageProgress } from '../../../../../api/TourSignup';
import SignupSuccessfulSubpage from './SignupSuccessfulSubpage';
import SignupFailedSubpage from './SignupFailedSubpage';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import SignupReviewSubpage from './SignupReviewSubpage';
import { Prospect } from '../../../../../api/Prospect';
import { clearSourceData } from '../../../../../utilities/sourceData';

const TourConfirmationPage = (props: TourSignupProps) => {
    useEffect(() => {
        if (props.match.params.guestCardGuid !== undefined) {
            updatePageProgress(props.match.params.guestCardGuid, PageProgress.Confirmation);
        }
    }, []);

    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const guestCardGuid = props.match.params.guestCardGuid;
    if (!guestCardGuid) {
        return <GuestCardLoadFailureDisplay error="Invalid Guest Card ID" />;
    }

    const [confirmation, setConfirmation] = useState<Prospect | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    const handleScheduleTour = async () => {
        setIsLoading(true);

        let result = await scheduleTour(property.id, guestCardGuid);

        if (result.success && result.data) {
            setConfirmation(result.data.prospect);
            setErrorMessage(undefined);
            setIsLoading(false);
            clearSourceData();
            history.replaceState(
                null,
                '',
                tourSignedUpPath(
                    props.match.params.propertySlug,
                    guestCardGuid,
                    result.data.prospect.tourInfo.guid
                )(TourPage.SignupSuccess)
            );
        } else {
            setErrorMessage(result.error || 'Tour Scheduling Failed');
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <LoadingDisplay />;
    }

    if (errorMessage) {
        return <SignupFailedSubpage errorMessage={errorMessage} tourProps={props} />;
    }

    if (confirmation) {
        return <SignupSuccessfulSubpage prospect={confirmation} />;
    }

    return (
        <SignupReviewSubpage
            guestCardGuid={guestCardGuid}
            handleScheduleTour={handleScheduleTour}
            property={property}
        />
    );
};

export default withRouter(TourConfirmationPage);



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/TourConfirmationPage.tsx